import React from 'react';
import { ShimmerCard } from '../../Pharmacy/Profile/components/Shimmer';

const CategoryShimmer = () => {
    return (
        <div className='py-2 px-6 mx-2 bg-white rounded-xl'>
            {[...Array(6)].map((_, index) => (
                <div 
                    key={index} 
                    className='flex items-center h-12 justify-between border-b last:border-b-0'
                >
                    <div className='flex space-x-3 items-center'>
                        <div className='animate-pulse bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 h-8 w-8 rounded-full' />
                        <div className='animate-pulse bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 h-4 w-32 rounded' />
                    </div>
                    <div className='animate-pulse bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 h-4 w-4 rounded' />
                </div>
            ))}
        </div>
    );
};

export default CategoryShimmer; 